export default __webpack_public_path__ + "images/touchId.v-a16642b1dc01a523183dfebe0665e650.svg";